var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Table, TableHead, TableBody, TableRow, TableCell, } from '@mui/material';
import { weightFormat } from '../../utils/format';
import { Check as CheckIcon } from '@mui/icons-material';
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  table {\n    width: 100%;\n  }\n"], ["\n  table {\n    width: 100%;\n  }\n"])));
var DeliveryRequestItemsTable = function (_a) {
    var items = _a.items, role = _a.role;
    var t = useTranslation().t;
    if (items.length === 0) {
        return React.createElement(Wrapper, null, t('messages.noDeliveryRequest'));
    }
    return (React.createElement(Wrapper, null,
        React.createElement(Table, { size: "small" },
            React.createElement(TableHead, null,
                React.createElement(TableRow, null,
                    React.createElement(TableCell, null, t('params.offer.lotNumber')),
                    role === 'admin' && (React.createElement(React.Fragment, null,
                        React.createElement(TableCell, null, t('params.warehouse.name')),
                        React.createElement(TableCell, { align: "center" }, 'Typica Selection Order'))),
                    React.createElement(TableCell, { align: "right" }, t('params.deliveryRequestItem.quantity')))),
            React.createElement(TableBody, null, items.map(function (item) { return (React.createElement(TableRow, { key: item.id },
                React.createElement(TableCell, null, item.warehouseItem.offer.lotNumber),
                role === 'admin' && (React.createElement(React.Fragment, null,
                    React.createElement(TableCell, null, item.warehouseItem.warehouse.name),
                    React.createElement(TableCell, { align: "center" }, item.warehouseItem.order.isTypicaStockOrder ? (React.createElement(CheckIcon, { style: { color: 'green' } })) : ('-')))),
                React.createElement(TableCell, { align: "right" },
                    item.quantity,
                    " (",
                    weightFormat(parseFloat(item.warehouseItem.offer.bagSize) * item.quantity),
                    ")"))); })))));
};
export default DeliveryRequestItemsTable;
var templateObject_1;
